import type { ReactElement } from "react";
import { memo } from "react";

import {
    type TabContentComponentProps,
    TabWithCounter,
} from "app/pages/sales-intelligence/common-components/tabbed-page-content";
import type { PageTabBase } from "app/pages/sales-intelligence/common-components/tabbed-page-content/types";
import type { LeadsType } from "app/pages/sales-intelligence/modules/leads-search/types";

import useLeadsSearchResult from "../../query/queries/useLeadsSearchResult";

type Props = TabContentComponentProps<PageTabBase<LeadsType>>;

const LeadsTabContainer = ({ tab, isSelected }: Props): ReactElement => {
    const { data, isFetching, isPending } = useLeadsSearchResult(tab.id);

    return (
        <TabWithCounter
            isLoading={isFetching || isPending}
            isSelected={isSelected}
            total={data?.totalCount}
            iconNameActive={tab.iconNameActive}
            iconNameInactive={tab.iconNameInactive}
            title={tab.title}
            withIconFill
        />
    );
};

export default memo(LeadsTabContainer);
